import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySliderModule } from '@angular/material/legacy-slider';

import {
  DfDynamicElementComponent,
  DfDynamicElementDirective,
  DynamicFormsErrorTemplateDirective,
} from './dynamic-element.component';
import { DynamicFormsComponent } from './dynamic-forms.component';
import { DYNAMIC_FORMS_PROVIDER } from './services/dynamic-forms.service';

import { DynamicCheckboxComponent } from './dynamic-elements/dynamic-checkbox/dynamic-checkbox.component';
import { DynamicDatepickerComponent } from './dynamic-elements/dynamic-datepicker/dynamic-datepicker.component';
import { DynamicFileInputComponent } from './dynamic-elements/dynamic-file-input/dynamic-file-input.component';
import { DynamicInputComponent } from './dynamic-elements/dynamic-input/dynamic-input.component';
import { DynamicSelectComponent } from './dynamic-elements/dynamic-select/dynamic-select.component';
import { DynamicSlideToggleComponent } from './dynamic-elements/dynamic-slide-toggle/dynamic-slide-toggle.component';
import { DynamicSliderComponent } from './dynamic-elements/dynamic-slider/dynamic-slider.component';
import { DynamicTextareaComponent } from './dynamic-elements/dynamic-textarea/dynamic-textarea.component';

const DF_DYNAMIC_FORMS: Type<any>[] = [
  DynamicFormsComponent,
  DfDynamicElementComponent,
  DfDynamicElementDirective,
  DynamicFormsErrorTemplateDirective,
];

const DF_DYNAMIC_FORMS_ENTRY_COMPONENTS: Type<any>[] = [
  DynamicInputComponent,
  DynamicFileInputComponent,
  DynamicTextareaComponent,
  DynamicSlideToggleComponent,
  DynamicCheckboxComponent,
  DynamicSliderComponent,
  DynamicSelectComponent,
  DynamicDatepickerComponent,
];

@NgModule({
  declarations: [
    DynamicFormsComponent,
    DfDynamicElementComponent,
    DfDynamicElementDirective,
    DynamicFormsErrorTemplateDirective,
    DynamicInputComponent,
    DynamicFileInputComponent,
    DynamicTextareaComponent,
    DynamicSlideToggleComponent,
    DynamicCheckboxComponent,
    DynamicSliderComponent,
    DynamicSelectComponent,
    DynamicDatepickerComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
    MatLegacySelectModule,
    MatLegacyCheckboxModule,
    MatLegacySliderModule,
    MatLegacySlideToggleModule,
    MatIconModule,
    MatLegacyButtonModule,
    MatDatepickerModule,
  ],
  exports: [...DF_DYNAMIC_FORMS, ...DF_DYNAMIC_FORMS_ENTRY_COMPONENTS],
  providers: [DYNAMIC_FORMS_PROVIDER],
})
export class DynamicFormsModule {}
